import { Link } from "react-router-dom";

import { t } from "../../utils/utils";

// First, last and the pages around the current one; gaps become "…".
function pageList(page, totalPages) {
  const pages = [];

  for (let p = 1; p <= totalPages; p++) {
    if (p === 1 || p === totalPages || Math.abs(p - page) <= 1) {
      pages.push(p);
    } else if (pages[pages.length - 1] !== "…") {
      pages.push("…");
    }
  }

  return pages;
}

// Page 1 is the plain URL so it matches links to /blog.
function pageLink(p) {
  return { search: p > 1 ? `?page=${p}` : "" };
}

export function Pagination({ page, totalPages }) {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <nav className="blogPagination" aria-label={t.pagination}>
      {page > 1 ? (
        <Link to={pageLink(page - 1)} className="blogPage" aria-label={t.prevPage}>
          ←
        </Link>
      ) : (
        <span className="blogPage disabled" aria-hidden="true">←</span>
      )}

      {pageList(page, totalPages).map((p, index) =>
        p === "…" ? (
          <span className="blogPageGap" key={`gap${index}`}>…</span>
        ) : (
          <Link
            to={pageLink(p)}
            key={p}
            className={`blogPage ${p === page ? "active" : ""}`}
            aria-current={p === page ? "page" : undefined}
          >
            {p}
          </Link>
        )
      )}

      {page < totalPages ? (
        <Link to={pageLink(page + 1)} className="blogPage" aria-label={t.nextPage}>
          →
        </Link>
      ) : (
        <span className="blogPage disabled" aria-hidden="true">→</span>
      )}
    </nav>
  );
}
